<template>
	<div class="o-grid c-toc">
		<div
			class="o-grid__column c-toc__link-wrapper"
			data-size="sm:12 md:4 lg:4"
		>
			<slot name="toc"></slot>
		</div>
		<div
			class="o-grid__column c-toc__content-wrapper richtext"
			data-size="sm:12 md:7 lg:7 offset:1"
			v-scroll-spy="{ offset: 0 }"
		>
			<slot name="content"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "VContentTocWrapper",

	props: {
		heading: {
			type: String
		},
		className: {
			type: String
		}
	}
};
</script>
